import Page from './page';
import BlogPost from './BlogPost';
import Row from './row';
import Navi from './Navi';
import NavItem from './Navi/nav_item';
import ComponentNotFound from './component_not_found';
import Cover from './Cover';
import HeaderText from './HeaderText';
import FullWidthContentBlock from './FullWidthContentBlock';
import RichText from './RichText';
import CTAButtonLink from './CTAButtonLink';
import ImageFeature from './ImageFeature';
import ImageResponsive from './ImageResponsive';
import LeadEnergyShield from './LeadEnergyShield';
import LeadFormV1 from './LeadFormV1';
import LeadFormV2 from './LeadFormV2';
import LeadFormSGIP from './LeadFormSGIP';
import LeadFormCX from './LeadFormCX';
import Footer from './Footer';
import Hero from './Hero';
import Video from './Video';
import AnchorTarget from './AnchorTarget';
import LandingPage from './LandingPage';
import EnergyShieldBadge from './EnergyShieldBadge';
import SplitContent from './SplitContent';
import ContentBlock from './ContentBlock';
import PressTimeline from './PressTimeline';
import { PressNewsMentions, PressNewsMention } from './PressNewsMentions';
import PressRelease from './PressRelease';
import IconsetWidget from './IconsetWidget';
import { MapLegend, MapLegendItem } from './MapLegend';
import BubbleFeature from './BubbleFeature';
import CCPANotice from './CCPANotice';
import ProductImage from './ProductImage';
import PartnerForm from './PartnerForm';
import PartnerName from './PartnerName';
import LeadFormPartner from './LeadFormPartner';
import LeadFormReferral from './LeadFormReferral';
import ArbitrationAgreement from './ArbitrationAgreement';
import BlogPostList from './BlogPostList';
import CCPADataRequest from './CCPADataRequest';
import { CriteoHomeTag, CriteoLandingTag } from './Criteo';
import AccentCard from './AccentCard';
import ContentCard from './ContentCard';
import CoverStripe from './CoverStripe';
import Spacer from './Spacer';
import FluidContentBlock from './FluidContentBlock';
import UtilityLeadForm from './UtilityLeadForm';
import LeadFormConEd from './LeadFormConEd';
import TemporaryRedirect from './TemporaryRedirect';
import HeaderVariantA from './HeaderVariantA';
import HeaderVariantB from './HeaderVariantB';
import JobList from './JobList';
import JobPost from './JobPost';
import LeadFormV3 from './LeadFormV3';
import Accordion from './Accordion';

const ComponentList = {
  page: Page,
  landing_page: LandingPage,
  blog_post: BlogPost,
  row: Row,
  navi: Navi,
  global_navi: Navi,
  nav_item: NavItem,
  cover: Cover,
  hero: Hero,
  header_text: HeaderText,
  content_block: ContentBlock,
  full_width_content_block: FullWidthContentBlock,
  rich_text: RichText,
  cta_button_link: CTAButtonLink,
  image_feature: ImageFeature,
  image_responsive: ImageResponsive,
  lead_energyshield: LeadEnergyShield,
  lead_form_v1: LeadFormV1,
  lead_form_v2: LeadFormV2,
  lead_form_sgip: LeadFormSGIP,
  lead_form_cx: LeadFormCX,
  video: Video,
  footer: Footer,
  anchor_target: AnchorTarget,
  energy_shield_badge: EnergyShieldBadge,
  split_content: SplitContent,
  press_timeline: PressTimeline,
  press_news_mentions: PressNewsMentions,
  press_news_mention: PressNewsMention,
  press_release: PressRelease,
  iconset_widget: IconsetWidget,
  map_legend: MapLegend,
  map_legend_item: MapLegendItem,
  bubble_feature: BubbleFeature,
  ccpa_notice: CCPANotice,
  product_image: ProductImage,
  partner_form: PartnerForm,
  partner_name: PartnerName,
  lead_form_partner: LeadFormPartner,
  lead_form_referral: LeadFormReferral,
  arbitration_agreement: ArbitrationAgreement,
  blog_post_list: BlogPostList,
  ccpa_data_request: CCPADataRequest,
  criteo_home_tag: CriteoHomeTag,
  criteo_landing_tag: CriteoLandingTag,
  accent_card: AccentCard,
  content_card: ContentCard,
  cover_stripe: CoverStripe,
  spacer: Spacer,
  fluid_content_block: FluidContentBlock,
  utility_lead_form: UtilityLeadForm,
  lead_form_con_ed: LeadFormConEd,
  temporary_redirect: TemporaryRedirect,
  header_variant_a: HeaderVariantA,
  header_variant_b: HeaderVariantB,
  job_list: JobList,
  job_post: JobPost,
  lead_form_v3: LeadFormV3,
  accordion: Accordion,
};

const Components = (type) => {
  if (typeof ComponentList[type] === 'undefined') {
    return ComponentNotFound;
  }
  return ComponentList[type];
};

export default Components;
